import _ from 'lodash';
import Slider from 'react-slick';
import GoToMarketPlaceBanner from '../Home/components/MarkerPlaceStrategies/GoToMarketPlaceBanner';
import GoToCreateStrategyBanner from 'ui/Home/components/MarkerPlaceStrategies/GoToCreateStrategyBanner';
import ReactHtmlParser from 'react-html-parser';

interface BannerCarouselItem {
  message: string;
}

const BannerCarousel: React.FC = () => {
  const { isUserSignedIn, SA_FEATURE_FLAGS } = window;
  const bannerCarousels: BannerCarouselItem[] = _.get(window, 'applicationDomain.config.bannerCarousels', []);
  const isShowMarketplaceInDashboard: boolean = isUserSignedIn && SA_FEATURE_FLAGS.isMarketPlaceAllowed;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true
  };

  return (
    <div className="banner-carousels mb-3">
      <Slider {...settings}>
        {bannerCarousels.length > 0
          ? bannerCarousels.map(({ message }, idx) => (
              <div className="carousel-items" key={idx}>
                {ReactHtmlParser(message)}
              </div>
            ))
          : isShowMarketplaceInDashboard
            ? <GoToMarketPlaceBanner />
            : <GoToCreateStrategyBanner />
        }
      </Slider>
    </div>
  );
};

export default BannerCarousel;
